<template>
  <v-app id="inspire">
    <v-progress-linear
      :active="$store.state.loading.length > 0"
      :indeterminate="$store.state.loading.length > 0"
      style="position: fixed; z-index: 999"
      color="blue-grey darken-4"
    />
    <v-app-bar elevation="1" app color="white" flat absolute>
      <span
        class="cy-app-logo cursor-pointer"
        @click="$route.name === 'Home' ? null : $router.push({ name: 'Home', query: $route.query })"
      >
        VP KINNISVARA
      </span>
      <v-spacer></v-spacer>
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text small icon v-bind="attrs" v-on="on"><v-icon>mdi-menu</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in ['Home', 'Typography', 'Apartments', 'Store']"
            :key="index"
            @click="$route.name !== item ? $router.push({ name: item, query: $route.query }) : null"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <base-btn
        text
        small
        outlined
        :loading="isSigningOut"
        v-if="$store.state.is_admin"
        @click="signOut"
        class="mr-2"
      >
        <span v-t="'Sign out'" />
      </base-btn>
      <!-- <LocaleSelect /> English locale does not have everything translated -->
    </v-app-bar>

    <v-main class="grey lighten-4 mt-md-5" :key="$i18n.locale">
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import LocaleSelect from "../LocaleSelect";
export default {
  components: {
    LocaleSelect,
  },
  data() {
    return {
      isSigningOut: null,
    };
  },
  methods: {
    async signOut() {
      this.isSigningOut = true;
      try {
        const response = await this.axios.post("/sign-out", {});
        this.errorMessage = null;
        location.reload();
      } catch (error) {
        console.log("error", error);
      } finally {
        this.isSigningOut = false;
      }
    },
  },
};
</script>
